import { render } from "./Fork.vue?vue&type=template&id=eb6f0d6a"
import script from "./Fork.vue?vue&type=script&lang=js"
export * from "./Fork.vue?vue&type=script&lang=js"

import "./Fork.vue?vue&type=style&index=0&id=eb6f0d6a&lang=css"
script.render = render

export default script